const CompliancesMasterFields = [
  {
    id: Math.random() * 10,
    name: "Compliances_Details",
    fields: [
      {
        id: Math.random() * 10,
        name: "name",
        label: "Name",
        type: "text",
        FirtsCharCap: true,
        min: 0,
        max: Infinity,
        isRequired: true,
      },
      {
        id: Math.random() * 10,
        name: "description",
        label: "Description",
        type: "textarea",
        min: 0,
        max: Infinity,
        isRequired: true,
      },
      {
        id: Math.random() * 10,
        name: "date",
        label: "Date",
        type: "Date",
      },
      {
        id: Math.random() * 10,
        name: "repeat",
        label: "Repeat",
        type: "inputdrop",
        dropdowncontent: ["Daily", "Weekly", "Fortnightly", "Monthly", "Every 3 Months", "Every 6 Months", "Yearly"],
      },
    ],
  },
];

export { CompliancesMasterFields };
